import { NavLink, useNavigate } from "react-router-dom";
import AuthSideImg from "./AuthSideImg";
import { IconMail } from "@tabler/icons-react";
import usePostRequest from "../../hooks/usePostRequest";
import { useState } from "react";
import { API_ENDPOINTS, aspetto_logo } from "../../constant/_constant";
import SuccessPopUp from "./SuccessPopUp";

const ForgotUsername = () => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
  });
  const navigate = useNavigate();

  const { data,isLoading, postData } = usePostRequest(API_ENDPOINTS.RESET_USERNAME);

  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSuccess = (response) => {
    setIsSuccessModalOpen(true);  
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    postData(formData, onSuccess);
  };

  return (
    <div className="row g-0 flex-fill">
{isSuccessModalOpen && <SuccessPopUp isOpen={isSuccessModalOpen} setIsOpen={setIsSuccessModalOpen}  dataForSuccessPage={data} HeadingContent={'Username has been sent.'}/>}

      <div className="col-12 col-lg-6 col-xl-4 border-top-wide border-warning d-flex flex-column justify-content-center">
        <div className="container container-tight my-5 px-lg-5">
          <div className="text-center w-50 mb-3 m-auto">
            <img src={aspetto_logo} height={80} alt="aspetto_logo" />
          </div>
          <h2 className="heading_login text-center mb-3">Retrieve Username</h2>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <input type="hidden" name="token" defaultValue="{{ $token }}" />
            <div className="mb-3">
              <label className="form-label">Your Email Address</label>
              <div className="input-group input-group-flat">
                <input
                  id="email"
                  type="email"
                  className="form-control"
                  name="email"
                  required
                  value={formData.email}
                  placeholder="Enter Email"
                  onChange={handleChange}
                />
                <span className="input-group-text">
                  <IconMail stroke={1} />
                </span>
              </div>
            </div>
            <div className="form-footer">
              <button
                type="submit"
                className={`btn btn-theme w-100 ${
                  isLoading ? "btn-loading" : ""
                }`}
                disabled={isLoading}
              >
                Send Username
              </button>
              <div className="text-center text-secondary mt-3">
               {" "}
                <NavLink to="/" tabIndex={-1}>
                Go back to sign in page.
                </NavLink>{" "}
              
              </div>
            </div>
          </form>
        </div>
      </div>
      <AuthSideImg />
    </div>
  );
};

export default ForgotUsername;
